import React, { useState } from "react";
import { toast } from "sonner";
import { EyeOff, Eye } from "lucide-react";
import { api, formatApiErrorDetail } from "../../lib/api";

// Compact inline tool: hide/show products on the web by ID (Discord inventory untouched).
export const HideByIdTool = () => {
    const [ids, setIds] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (hidden) => {
        const skus = ids.split(/[\s,;]+/).map((s) => s.trim()).filter(Boolean);
        if (!skus.length) return toast.info("Escribe uno o más IDs (ej. T-0012)");
        setBusy(true);
        try {
            const { data } = await api.post("/admin/hidden-products", { skus, hidden });
            toast.success(`${hidden ? "Ocultados" : "Visibles de nuevo"}: ${data.updated.join(", ")}`);
            if (data.not_found?.length) toast.warning(`No encontrados: ${data.not_found.join(", ")}`);
            setIds("");
            window.dispatchEvent(new Event("tb-hidden-products-changed"));
        } catch (e) {
            toast.error((e.response?.data?.detail ? formatApiErrorDetail(e.response.data.detail) : "No se pudo actualizar"));
        } finally {
            setBusy(false);
        }
    };

    return (
        <form
            onSubmit={(e) => { e.preventDefault(); submit(true); }}
            className="flex items-center gap-1.5 border border-[var(--tb-border)] rounded-full pl-3 pr-1 py-1 bg-[var(--tb-bg-2)] focus-within:border-[var(--tb-gold)]/60 transition-colors"
            data-testid="hide-by-id-tool"
        >
            <EyeOff className="w-3.5 h-3.5 text-[var(--tb-gold)] flex-shrink-0" />
            <input
                value={ids}
                onChange={(e) => setIds(e.target.value)}
                placeholder="Ocultar por ID (ej. T-0012)"
                className="bg-transparent outline-none text-xs w-44 placeholder:text-[var(--tb-muted)]"
                data-testid="hide-by-id-input"
            />
            <button type="submit" disabled={busy}
                className="text-[11px] px-2.5 py-1 rounded-full bg-[var(--tb-gold)] text-black font-medium disabled:opacity-50"
                data-testid="hide-by-id-submit">
                Ocultar
            </button>
            <button type="button" disabled={busy} onClick={() => submit(false)} title="Volver a mostrar"
                className="text-[11px] px-2 py-1 rounded-full text-[var(--tb-text-2)] hover:text-[var(--tb-gold)] disabled:opacity-50"
                data-testid="hide-by-id-show">
                <Eye className="w-3.5 h-3.5" />
            </button>
        </form>
    );
};
